import {memo} from 'react';
import {EditButton} from '~/common/components/EditButton/EditButton';
import type {ModuleProps} from '~/ViewInvitation/types/module';
import {isPreview} from '~/ViewInvitation/utils';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {HostDetails} from './HostDetails/HostDetails';
import {HostMessage} from './HostMessage';

export const DetailsModule = memo(
  ({preview = isPreview(), readonly = true, disableContent = false, editBtnRef}: ModuleProps) => {
    const isDesktop = useIsLargishAndUp();

    const editable = preview && !readonly;
    const isMwAndEditable = editable && !isDesktop;
    const isDesktopAndEditable = editable && isDesktop;
    return (
      <>
        <EditButton
          data-qa-id="edit-host-details-module"
          ref={editBtnRef}
          hide={!isMwAndEditable}
        />
        <div className="view-invitation__event-info" id="event-details-module">
          <HostDetails readonly={!isDesktopAndEditable} disableContent={disableContent} />
          <HostMessage readonly={!isDesktopAndEditable} />
        </div>
      </>
    );
  }
);

DetailsModule.displayName = 'DetailsModule';
